import React from 'react';
import { ShoppingCart, User, Menu } from 'lucide-react';
export function Header() {
  return <header className="w-full border-b border-gold/20 bg-ivory sticky top-0 z-50" data-id="element-26">
      <div className="bg-ink text-center py-2.5 text-xs tracking-[0.2em] font-medium text-gold uppercase" data-id="element-27">
        Recomendado por expertos en salud metabólica
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="flex justify-between items-center h-20" data-id="element-29">
          <div className="flex items-center" data-id="element-30">
            <button className="sm:hidden p-2 text-ink hover:text-gold transition-colors" data-id="element-31">
              <Menu className="h-6 w-6" data-id="element-32" />
            </button>
            <a href="#" className="text-2xl sm:text-3xl font-serif text-ink ml-2 sm:ml-0 tracking-wide" data-id="element-33">
              METABOLIC<span className="text-gold italic" data-id="element-34">Science</span>
            </a>
          </div>

          <nav className="hidden sm:flex space-x-10" data-id="element-35">
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-36">
              La Guía
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-37">
              Cómo Funciona
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-38">
              Testimonios
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-39">
              FAQ
            </a>
          </nav>

          <div className="flex items-center space-x-6" data-id="element-40">
            <button className="text-ink hover:text-gold transition-colors" data-id="element-41">
              <User className="h-5 w-5 stroke-[1.5]" data-id="element-42" />
            </button>
            <a href="https://newdigitalguide.com/products/peptidos-glp-1-y-perdida-de-peso-guia-educativa" aria-label="Ir al carrito" className="text-ink hover:text-gold transition-colors" data-id="element-43">
              <ShoppingCart className="h-5 w-5 stroke-[1.5]" data-id="element-44" />
            </a>
          </div>
        </div>
      </div>
    </header>;
}